import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import HomePage from "./components/pages/HomePage";
import MentionsLegales from "./components/pages/MentionsLegales";
import PolitiqueConfidentialite from "./components/pages/PolitiqueConfidentialite";
import GestionCookies from "./components/pages/GestionCookies";
import { CookieProvider } from "./contexts/CookieContext";
import CookieBanner from "./components/CookieBanner";

function App() {
  useEffect(() => {
    // Set page title
    document.title = 'SISENS';
  }, []);

  return (
    <HelmetProvider>
      <CookieProvider>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/gestion-cookies" element={<GestionCookies />} />
          </Routes>
          <CookieBanner />
        </Router>
      </CookieProvider>
    </HelmetProvider>
  );
}

export default App;